import { inject } from "inversify-props";
import { HttpService } from "./HttpService";
import { ConfigService } from "./config/ConfigService";

export class FooterService {
  @inject("HttpService") httpService: HttpService;
  @inject("ConfigService") configService: ConfigService;

  async getFooterList(): Promise<any> {
    const footerUrl = this.configService.getConfig("footerUrl");
    return await this.httpService.get<any>(footerUrl);
  }
}
